import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { EmailConfirmPageContent } from 'client/contents/EmailConfirmPageContent/EmailConfirmPageContent'

type TProps = {}

const EmailConfirmPage: FC<TProps> = () => {
  return (
    <article className="flex flex-1 flex-col">
      <AppHead />
      <EmailConfirmPageContent />
    </article>
  )
}

export default EmailConfirmPage
